import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { evAgeLabel } from "./optimizerHelper";
import { IParlayOutcome, IShopOutcome } from "./store/types";
import Row from './Row';

export const createOptimizerMobileColumns = (
  getType: (o: IShopOutcome) => "Add" | "Swap" | "Remove",
  handleLegClick: (o: IParlayOutcome) => void,
  isDisplayUnlocked: boolean,
  exposureCounts: Map<string, number>,
): GridColDef[] => [
//     {
//         field: "expectedWinPct",
//         headerName: "xWIN",
//         headerAlign: "center",
//         flex: 0.1,
//         align: "center",
//         sortable: true,
//         renderCell(params) {
//           if (!isDisplayUnlocked) {
//             return <LockIcon />;
//           }
//           return params.value;
//         },
//       },
//   {
//     field: "evAge",
//     headerName: "Age",
//     headerAlign: "center",
//     flex: 0.1,
//     sortable: true,
//     align: "center",
//     valueGetter(params) {
//       return params.row.evAge;
//     },
//   },
//   {
//     field: "oddsAmerican",
//     headerName: "True Odds",
//     flex: 0.1,
//     headerAlign: "center",
//     align: "center",
//     sortable: true,
//   },
//   {
//     field: "exposure",
//     headerName: "Exposure",
//     flex: 0.1,
//     headerAlign: "center",
//     align: "center",
//     sortable: true,
//     valueGetter(params) {
//         return 0;
//     }
//   },
  {
    field: "",
    headerName: "",
    flex: 1,
    headerAlign: "left",
    renderCell(params: GridRenderCellParams<IShopOutcome>) {
      const type = getType(params.row);
      const { expectedWinPct, evAge, oddsAmerican } = params.row;

      let lineupCount = exposureCounts.get("lineupCount");
      if (!lineupCount) {
        lineupCount = 0;
      }
      let count = exposureCounts.get(params.row.playerId);
      if (!count) {
        count = 0;
      }
      let exposure = count !== 0 ? (count / lineupCount) * 100 : 0;
      return (
        <Row
          isUserPremium={isDisplayUnlocked}
          parlayOutcome={params.row}
          type={type}
          onClick={handleLegClick}
          contrastCardBackground={false}
          dataPoints={[
            {
              header: "xWin",
              data: expectedWinPct || "-",
              highlight: parseInt(expectedWinPct || "0") / 200,
            },
            {
              header: "Age",
              data: evAgeLabel(evAge),
            },
            {
              header: "True Odds",
              data: oddsAmerican,
            },
            {
              header: "Exposure",
              data:  `${exposure.toFixed(2)}%`,
            },
          ]}
        />
      );
    },
  },
];
